




































































































































import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import moment from 'moment';
import ModalOrderDraft from '@/components/request/ModalOrderDraft.vue';
import * as s_Interface from '@/interface/store/manageGroups';
import { openSuggestions } from '@/utils/common';

const dateParser = (utc: Date) => moment(utc).format('YYYY-MM-DD');

@Component({
  components: {
    ModalOrderDraft,
  },
})
export default class OrderDraft extends Vue {
  @Action('getAddresses', { namespace: 'manageGroup' }) c_getAddresses!: any;

  @Getter('getterUser', { namespace: 'profile' }) c_getterUser!: any;
  @Getter('getterAddresses', { namespace: 'manageGroup' }) c_getterAddresses!: Array<
    s_Interface.AddressData
  >;

  public dialogVisibleStatus: boolean = false;
  public dataItems: any = [];
  public ruleForm: any = {
    fkVendor: {
      name: null,
      contactName: null,
      contactPhone: null,
      contactEmail: null,
    },
    purchaseOrder: null,
    orderDate: null,
    draftDate: null,
    organization: null,
    contactName: null,
    phone: null,
    address: null,
    notes: null,
  };
  public rules: any = {};
  public addressLinks: any = [];
  public changeAddressInput: boolean = false;
  public syncedAddressName = '';
  public openSuggestions: Function = openSuggestions;

  async created() {
    this.dataItems = this.$route.query.items;
    if (this.dataItems[0].fkVendorId && this.dataItems[0].fkVendor) {
      this.ruleForm.fkVendor = this.dataItems[0].fkVendor;
    }
    if (this.dataItems[0].fkPurchaseOrderId && this.dataItems[0].fkPurchaseOrder) {
      this.ruleForm.purchaseOrder = this.dataItems[0].fkPurchaseOrder.name;
    }
    this.ruleForm.orderDate = dateParser(new Date());
    this.ruleForm.draftDate = dateParser(new Date());
    this.ruleForm.organization = this.c_getterUser.organization;
    this.ruleForm.contactName = this.c_getterUser.fullName;
    this.ruleForm.phone = this.c_getterUser.phoneNumber;
    this.ruleForm.email = this.c_getterUser.email;

    const groupId: string = this.$route.params.groupId;
    await this.c_getAddresses(groupId);
    const isActiveAddress: any = this.c_getterAddresses.find(
      (address: any) => address.isActive === true
    );
    this.ruleForm.address = `${isActiveAddress.address} ${isActiveAddress.detailAddress}`;
    this.syncedAddressName = `${isActiveAddress.address} ${isActiveAddress.detailAddress}`;
    this.addressLinks = this.c_getterAddresses;
  }

  currentItemTotalPrice(item: any) {
    const quantity: number = item.quantity;
    const price: number = item.price;
    const totalPrice = quantity * price;
    const commaParse = totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return isNaN(totalPrice) ? 0 : commaParse;
  }

  viewPDF() {
    this.dialogVisibleStatus = true;
  }

  viewCancel() {
    this.$router.go(-1);
  }

  createFilter(queryString: string) {
    return (link: any) => link.address.indexOf(queryString) === 0;
  }

  addressQuerySearch(queryString: string, cb: any) {
    const addressLinks = this.addressLinks;
    const changeAddressInput = this.changeAddressInput;
    if (changeAddressInput) {
      const results = queryString
        ? addressLinks.filter(this.createFilter(queryString))
        : addressLinks;
      cb(results);
    } else {
      cb(addressLinks);
    }
  }

  addressHandleSelect(item: any) {
    this.ruleForm.address = `${item.address} ${item.detailAddress}`;
    this.syncedAddressName = `${item.address} ${item.detailAddress}`;
    this.changeAddressInput = false;
  }

  addressHandleInput() {
    this.changeAddressInput = true;
  }

  addressHandleChange(queryString: any) {
    if (queryString) {
      this.ruleForm.address = queryString;
      this.syncedAddressName = queryString;
    }
  }
}
